import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { JobService } from 'src/app/services/job.service';
import Job from 'src/app/interfaces/Event';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-jobs-single',
  templateUrl: './jobs-single.component.html',
  styleUrls: ['./jobs-single.component.scss'],
})
export class JobsSingleComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  job$: Observable<any>;
  job: Job;
  currentUser;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private jobService: JobService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('job_detail_view');
    this.job$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => this.jobService.getCurrentJob(params.get('id')))
    );
    this.subscriptions.add(
      this.job$.subscribe((j) => {
        this.job = j[0];
      })
    );

    // Get user
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
        }
      })
    );
  }

  trackEvent(name: string): void {
    this.analyticsService.event(name);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
